<template>
  <div class="index">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>Conference</span> <b>→</b>
        <span>Eurodrying - European Drying Conference</span>
      </div>
      <div class="title">European Drying Conference (Eurodrying)</div>
      <div class="box">
        <div class="box-title">Eurodrying Introduction</div>
        <div class="text">
          For the drying community, the IDS series initiated by Prof. Arun Mujumdar is a
          worldwide meeting place. Encouraged by the success of this worldwide event,
          satellite series of drying conferences have been developed in different parts of
          the world (Asia/Australia, South America, etc.). However, in spite of its
          recognized place in the drying community, Europe still did not have a unique and
          recognized drying conference series of its own. Indeed, at least three series of
          drying conferences coexisted in European countries or European regions. This
          explains why it was not easy to merge these regional conferences into one single
          series of European events. Previous attempts included the European Drying
          Conferences, such as the ones organized by Prof. G. Saravacos in Crete (Greece)
          in 2004, Prof. J. Andrieu in Biarritz (France) in 2007, and Profs. J. Andrieu
          and P. Perré in Lyon in 2009.
        </div>
        <br />
        <div class="text">
          In our Working Party on Drying of the European Federation of Chemical
          Engineering (EFCE), this goal has been on the business meeting agenda for many
          years. Since my election as the new chairman of this Working Party in 2008, I
          encouraged our group to work mostly on this question and, finally, a consensus
          was reached during the meeting held in Magdeburg, Germany, during
          IDS'2010. Therefore, it is my great pleasure to write this short report on
          EuroDrying'2011 organized in Palma de Mallorca, Spain, by Prof. Carmen Rossello,
          under the auspices of EFCE.
        </div>
        <br />
        <div class="text text-right">——Prof. Patrick Perré</div>
        <br />
        <div class="text text-right">
          <a href="https://doi.org/10.1080/07373937.2011.647533" target="_blank">
            https://doi.org/10.1080/07373937.2011.647533
          </a>
        </div>
        <div class="box-title">Upcoming European Drying Conferences</div>

        <div class="card">
          <div class="card-title">9th European Drying Conference</div>
          <div class="left">
            <p>July 6-9, 2025</p>
            <p>Wageningen, Netherlands</p>
            <br />
            <p>Organizer: Wageningen University & Research</p>
            <p>E-mail: eurodrying2025@wur.nl</p>
            <p>
              Website:
              <a href="https://www.eurodrying2025.nl" target="_blank"> www.eurodrying2025.nl </a>
            </p>
          </div>
          <img src="@/assets/images/new-021.png" alt="" />
        </div>
        <div class="box-title">Previous European Drying Conferences</div>
        <div class="text text-center">
          <p>
            Previous attempts included the European Drying Conferences, such as the ones
            organized by:
          </p>
          <p>Prof. G. Saravacos in Crete (Greece) in 2004,</p>
          <p>Prof. J. Andrieu in Biarritz (France) in 2007,</p>
          <p>Profs. J. Andrieu and P. Perré in Lyon (France) in 2009.</p>
          <br />
          <p v-for="(i, num) in list" :key="num">{{ i.label }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          label:
            "3rd European Drying Conference (EuroDrying 2011): Palma de Mallorca, Spain",
        },
        {
          label: "4th European Drying Conference (EuroDrying 2013): Paris, France",
        },
        {
          label: "5th European Drying Conference (EuroDrying 2015): Budapest, Hungary",
        },
        {
          label: "6th European Drying Conference (EuroDrying 2017): Liège, Belgium",
        },
        {
          label: "7th European Drying Conference (EuroDrying 2019): Turin, Italy",
        },
        {
          label: "8th European Drying Conference (EuroDrying 2023): Łódź, Poland",
        },
        {
          label:
            "9th European Drying Conference (EuroDrying 2025): Wageningen, Netherlands",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .small-title {
    margin: 25px 0;
    font-weight: 600;
  }

  .card {
    padding: 25px 15px;
    box-sizing: border-box;
    position: relative;
    font-weight: 700;
    line-height: 1.9;
    background-color: hsla(0, 0%, 50.2%, 0.05);

    .card-title {
      color: #5b965a;
      margin-bottom: 20px;
    }

    img {
      position: absolute;
      bottom: 100px;
      right: 35px;
      width: auto;
      height: 100px;
    }
  }

  .box {
    padding: 0 100px;
    box-sizing: border-box;
  }

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .text-right {
    text-align: right;
  }

  .text-center {
    width: 750px;
    margin: 0 auto;
  }

  .text-green {
    color: #5b965a;
  }

  .title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 630px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .box-title {
    text-align: center;
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    width: 100%;
    margin-top: 50px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 600px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 11px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}
@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .card img {
      position: relative;
      right: 0;
      bottom: 0;
    }

    .title {
      font-size: 20px;
    }

    .box-title {
      font-size: 18px;
    }

    .box {
      padding: 0 10px;
    }

    .text-center {
      width: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/eurodrying.vue